"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_calendar__22__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "76794bb2-b7d6-4f70-b8ae-72fe5734849d",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a76d0f00-bbf8-485e-b430-b68d23a487e9",
    x1: 59.82,
    y1: 28.29,
    x2: 179.23,
    y2: 147.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "calendar-22-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "0deb85d3-ab6f-470a-a013-44a59ed3a929",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "56afcba0-c973-491f-88c9-73d1242187bd",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b23100b8-28e3-494d-8657-96eb82bcfd3b",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1533ebbe-038e-44aa-b9d8-dce33cf0183d",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09edb79a-a2d3-4b48-874d-c939777582ce",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aae2d7a0-4f3e-44b8-8a51-5093aff793eb",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "22d3cada-225f-4182-b379-925a32f4e022",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,152a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16V64H24Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,166H40a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H152a16,16,0,0,0,16-16v-2A16,16,0,0,1,152,166Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,24H32a8,8,0,0,0-8,8V64H168V32A8,8,0,0,0,160,24ZM52,40a4,4,0,1,1,4-4A4,4,0,0,1,52,40Zm88,0a4,4,0,1,1,4-4A4,4,0,0,1,140,40Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 62,
    width: 144,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52,30a4,4,0,0,0-3.86,5,4,4,0,0,1,7.72,0A4,4,0,0,0,52,30Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,30a4,4,0,0,0-3.86,5,4,4,0,0,1,7.72,0A4,4,0,0,0,140,30Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "7dcaa2f9-8ab8-44a4-ad9b-354194270cbd",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.51,64.13l-123.33-.2h-20v.59L128.34,168H152a19,19,0,0,0,4.24-.37,16.3,16.3,0,0,0,8.52-5.64,15.86,15.86,0,0,0,3.39-9.81V64.79Z",
    transform: "translate(0 0)",
    opacity: 0.1,
    fill: "url(#a76d0f00-bbf8-485e-b430-b68d23a487e9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.89,24.63A7.92,7.92,0,0,1,31.19,24,7.92,7.92,0,0,0,28.89,24.63Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.54,25.37a8.1,8.1,0,0,0-1.7,1.55A8.1,8.1,0,0,1,27.54,25.37Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  })))))))), /*#__PURE__*/React.createElement("path", {
    d: "M59.56,137.46V134A15.6,15.6,0,0,1,61,126.54a27.05,27.05,0,0,1,5.46-6.38l7-6.38a71.07,71.07,0,0,0,6.58-6.62,13.36,13.36,0,0,0,2.67-4.47,14.19,14.19,0,0,0,.56-4q0-4.55-2.27-6.9a8.63,8.63,0,0,0-6.5-2.35,13.3,13.3,0,0,0-5.94,1.43A26.45,26.45,0,0,0,62,96l-3-4.54a32.46,32.46,0,0,1,5-4.23,18.64,18.64,0,0,1,5.5-2.63,21,21,0,0,1,5.7-.8,15.11,15.11,0,0,1,8.57,2.31,12.33,12.33,0,0,1,4.78,5.5,16.44,16.44,0,0,1,1.32,6.3,17.59,17.59,0,0,1-2.27,9,35.32,35.32,0,0,1-7.38,8.37L72.56,122a26.32,26.32,0,0,0-5.1,5.34A8.65,8.65,0,0,0,66.1,132h25v5.42Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.47,137.46V134a15.6,15.6,0,0,1,1.48-7.42,27.05,27.05,0,0,1,5.46-6.38l7-6.38a71.07,71.07,0,0,0,6.58-6.62,13.36,13.36,0,0,0,2.67-4.47,14.19,14.19,0,0,0,.56-4q0-4.55-2.27-6.9a8.63,8.63,0,0,0-6.5-2.35,13.3,13.3,0,0,0-5.94,1.43,26.45,26.45,0,0,0-6.58,5.1l-3-4.54a32.46,32.46,0,0,1,5-4.23,18.64,18.64,0,0,1,5.5-2.63,21,21,0,0,1,5.7-.8,15.11,15.11,0,0,1,8.57,2.31,12.33,12.33,0,0,1,4.78,5.5,16.44,16.44,0,0,1,1.32,6.3,17.59,17.59,0,0,1-2.27,9,35.32,35.32,0,0,1-7.38,8.37l-7.65,6.7a26.32,26.32,0,0,0-5.1,5.34A8.65,8.65,0,0,0,107,132h25v5.42Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }));
}

var _default = ic_calendar__22__dark;
exports.default = _default;